import dayjs from 'dayjs';
import React, { useState } from 'react'
import { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Form, Schema, SelectPicker } from 'rsuite';
import credentialService from '../../../../services/Internal/Credential/credential.service';
import { getCredStatus, getCredStatusReason, formatStatusReasonLabel } from '../../../../services/Shared/codeTable.service';
import RedStar from '../../../Shared/GenericComponents/RedStar';



function FirmCredentialForm(props) {
    const [formData, setFormData] = useState({});
    const [credStaus, setCredStaus] = useState([])
    const [credReason, setCredReason] = useState([])
    useEffect(() => {
        setFormData({
            ...props.credential,
            applicationDate: props.credential.applicationDate != null ? dayjs(props.credential.applicationDate).format('YYYY-MM-DD') : null,
            expirationDate: props.credential.expirationDate != null ? dayjs(props.credential.expirationDate).format('YYYY-MM-DD') : null,
            effectiveDate: props.credential.effectiveDate != null ? dayjs(props.credential.effectiveDate).format('YYYY-MM-DD') : null,
            reinstatementDate: props.credential.reinstatementDate != null ? dayjs(props.credential.reinstatementDate).format('YYYY-MM-DD') : null,
            firstIssuanceDate: props.credential.firstIssuanceDate != null ? dayjs(props.credential.firstIssuanceDate).format('YYYY-MM-DD') : null,
            certificateSentDate: props.credential.certificateSentDate != null ? dayjs(props.credential.certificateSentDate).format('YYYY-MM-DD') : null,
            dateMod: props.credential.dateMod != null ? dayjs(props.credential.dateMod).format('YYYY-MM-DD') : null,
            statusReasonLabel: formatStatusReasonLabel(props.credential.statusReason?.statusReason, props.credential.status?.status),
            statusLabel: props.credential.status?.status,
            status: props.credential.status,
            statusReason: props.credential.statusReason,

        });

        getCredStatus().then(setCredStaus);
        getCredStatusReason(props.credential.status?.id, props.credential.status?.status).then(setCredReason);
    }, [props.credential])

    const { ObjectType } = Schema.Types;
    const model = Schema.Model({
        statusReason: ObjectType().isRequired('This field is required.'),
        status: ObjectType().isRequired('This field is required.'),

    })

    const handleCredentialStatusChange = (val) => {
        setFormData({ ...formData, status: val, statusReason: null })
        getCredStatusReason(val?.id, val?.status).then(setCredReason);
    }

    const submitForm = (validation, event) => {
        if (validation) {
            var dataToTransmit = {
                ...formData,
                expirationDate: formData.expirationDate == '' ? null : formData.expirationDate,
                certificateSentDate: formData.certificateSentDate == '' ? null : formData.certificateSentDate,
                effectiveDate: formData.effectiveDate == '' ? null : formData.effectiveDate,
                reinstatementDate: formData.reinstatementDate == '' ? null : formData.reinstatementDate,
            }
            switch (formData.licenseTypePrefix) {
                case 'VF':
                    credentialService.updateVfCredential(dataToTransmit).then((response) => {
                        props.saveSuccess(response.data)
                        if (dataToTransmit.status.id != 1) {
                            props.updateSupervisedCardCallback()
                        }
                    });
                    break;
                case 'EF':
                    credentialService.updateEfCredential(dataToTransmit).then((response) => {
                        props.saveSuccess(response.data)
                        if (dataToTransmit.status.id != 1) {
                            props.updateSupervisedCardCallback()
                        }
                    })
                default:
            }

        }
    }

    return (
        <Form id={props.formId} fluid model={model} formValue={formData} onChange={setFormData} onSubmit={submitForm} >
            <Row className="mb-3">
                <Col>
                    <Form.ControlLabel><b>Credential #</b></Form.ControlLabel>
                    <Form.Control name="formattedLicenseNumber" disabled />
                </Col>
                <Col>
                    <Form.ControlLabel><b>Credential Status</b> {props.editMode && <RedStar />}</Form.ControlLabel>
                    {props.editMode ?
                        <Form.Control
                            name="status"
                            block
                            data={credStaus}
                            accepter={SelectPicker}
                            searchable={false}
                            placeholder="Select Status"
                            onChange={handleCredentialStatusChange} /> :
                        <Form.Control name="statusLabel" block disabled />
                    }
                </Col>
                <Col>
                    <Form.ControlLabel><b>Credential Reason</b> {props.editMode && <RedStar />}</Form.ControlLabel>
                    {props.editMode ?
                        <Form.Control
                            name="statusReason"
                            block
                            data={credReason}
                            accepter={SelectPicker}
                            searchable={false}
                            readOnly={!formData.status}
                            placeholder="Select Status Reason" /> :
                        <Form.Control name="statusReasonLabel" block disabled />
                    }
                </Col>


            </Row>
            <Row className="mb-3">
                <Col>
                    <Form.ControlLabel><b>First Issuance Date</b></Form.ControlLabel>
                    <Form.Control name="firstIssuanceDate" type={props.editMode ? "date" : 'text'} disabled />
                </Col>

                <Col>
                    <Form.ControlLabel><b>Effective Date</b></Form.ControlLabel>
                    <Form.Control
                        name="effectiveDate"
                        type={props.editMode ? "date" : 'text'}
                        disabled={!props.editMode} />
                </Col>
                <Col>
                    <Form.ControlLabel><b>Expiration Date</b></Form.ControlLabel>
                    <Form.Control
                        name="expirationDate"
                        type={props.editMode ? "date" : 'text'}
                        disabled={!props.editMode} />
                </Col>
            </Row>
            <Row className="mb-3">
                <Col>
                    <Form.ControlLabel><b>Application Date</b></Form.ControlLabel>
                    <Form.Control name="applicationDate" type={props.editMode ? "date" : 'text'} disabled />
                </Col>
                <Col>
                    <Form.ControlLabel><b>Application Type</b></Form.ControlLabel>
                    <Form.Control name="applicationType" disabled />
                </Col>
                <Col>
                    <Form.ControlLabel><b>Reinstatement Date</b></Form.ControlLabel>
                    <Form.Control
                        name="reinstatementDate"
                        type={props.editMode ? "date" : 'text'}
                        disabled={!props.editMode} />
                </Col>
            </Row>
            <Row className="mb-3">
                <Col>
                    <Form.ControlLabel><b>Licensed By</b></Form.ControlLabel>
                    <Form.Control name="approvedBy" disabled />
                </Col>
                <Col>
                    <Form.ControlLabel><b>Last Updated By</b></Form.ControlLabel>
                    <Form.Control name="userMod" disabled />
                </Col>
                <Col>
                    <Form.ControlLabel><b>Date of Last Activity</b></Form.ControlLabel>
                    <Form.Control name="dateMod" disabled />
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.ControlLabel><b>Certificate Sent Date</b></Form.ControlLabel>
                    <Form.Control
                        name="certificateSentDate"
                        type={props.editMode ? "date" : 'text'}
                        disabled={!props.editMode} />
                </Col>
                <Col></Col>
                <Col></Col>
            </Row>
        </Form>
    );
}

export default FirmCredentialForm;